const DocumentSearch = () => import('@/views/documents/DocumentSearch');

const routerDashboard = [
  {
    path: '/admin/documents',
    name: 'Widgets List All',
    component: DocumentSearch,
    meta: {
      requiresAuth: true,
      title: 'ค้นหาเอกสาร',
      breadcrumb: 'Dashboard / Search Documents'
    }
  }
]

export default routerDashboard
